import type { EngineEvent } from '../../interfaces/websocket-events.interface'

export const asString = (val: unknown): string => (typeof val === 'string' ? val : '')

export const asStringOrUndefined = (val: unknown): string | undefined =>
  typeof val === 'string' ? val : undefined

export const asStringOrNull = (val: unknown): string | null =>
  typeof val === 'string' ? val : null

export const asBoolean = (val: unknown): boolean => val === true

export const asNumber = (val: unknown, fallback: number): number =>
  typeof val === 'number' ? val : fallback

export const asRecord = (val: unknown): Record<string, unknown> =>
  typeof val === 'object' && val !== null ? (val as Record<string, unknown>) : {}

export interface IdContext {
  conversationId: string
  messageId: string
}

export const extractIds = (event: EngineEvent): IdContext | null => {
  const conversationId = asString(event.data.conversation_id)
  const messageId = asString(event.data.message_id)
  if (!conversationId || !messageId) return null
  return { conversationId, messageId }
}

export const composeTurnEntityId = (
  threadId: string | undefined,
  messageRunId: string,
  fallbackId: string
): string => {
  if (threadId && messageRunId) return `${threadId}::${messageRunId}`
  return fallbackId
}
